import { render, staticRenderFns } from "./AddStoredValue.vue?vue&type=template&id=b033e1e8&"
import script from "./AddStoredValue.vue?vue&type=script&lang=js&"
export * from "./AddStoredValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports